<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST' && allowList" class="secondary-toolbar-item selectable" (click)="showList()"><mat-icon>list</mat-icon>All Certifications</div>
  <ng-container *ngIf="selectedAssessment">
    <div class="secondary-toolbar-item"><mat-icon *ngIf="allowList" svgIcon="cw:action_next"></mat-icon>{{selectedAssessment.assessmentName}} {{selectedAssessment.updatedAt | date:'short'}}</div>
  </ng-container>
  
  <!-- since report is not created for CERTIFICATION type
    ng-container *ngIf="state=='ASSESSMENT_REPORT'">
    <div class="secondary-toolbar-item selectable" style="margin: 0 0 0 auto;" aria-label="Get Full Report" (click)="getAssessmentReport()">
      <mat-icon>description</mat-icon> Get Full Report
    </div>
  </ng-container-->
</mat-toolbar>

<app-grid-spinner #spinner></app-grid-spinner>

<section class="main-content">      
  <cw-ci-account-certification-list *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" [parentAccount]='getParentAccount()' [account]='getWorkingAccount()'></cw-ci-account-certification-list>
  <cw-ci-assessment-work *ngIf="state=='EDIT_ASSESSMENT'" (stateChange)="onStateChange($event)" [account]='account' [accountAssessment]='selectedAssessment'></cw-ci-assessment-work>
  <cw-ci-assessment-report *ngIf="state=='ASSESSMENT_REPORT'" (stateChange)="onStateChange($event)" [account]='account' [accountAssessment]='selectedAssessment'></cw-ci-assessment-report>
  <ng-container *ngIf="state=='COMPLETEDASSESSMENT'">
    <div class="dashboard-tile mat-elevation-z4" style="width:400px; height:500px; margin: auto;">
      <div class="tile-header">
        <div class="tile-header-title">Assessment Completed</div>
      </div>
      <div class="tile-content" style="text-align:center">
        <h2 style="padding-top:50px">THANK YOU</h2>
        <div style="padding:0 20px 20px 20px;">You have completed your certification assessment. Please click the button below to access
          your results.</div>
        <button mat-raised-button color="primary" (click)="state='ASSESSMENT_REPORT'">Show My Results</button>
      </div>
    </div>
  </ng-container>

</section>
